import { AuthenticatedLayout } from "@components/layouts/AuthenticatedLayout";
import { DraftView } from "@containers/draft/DraftView";

const DraftSessionsPage = () => {
    return (
        <AuthenticatedLayout activeMenuItem="draft">
            <DraftView />
        </AuthenticatedLayout>
    );
}

export default DraftSessionsPage;
                            